import * as React from "react";

function SvgMail(props) {
  return (
    <svg width={16} height={16} {...props}>
      <defs>
        <clipPath id="mail_svg__prefix__clip-path">
          <path
            id="mail_svg__prefix__Ret\xE2ngulo_227"
            fill="currentColor"
            stroke="currentColor"
            d="M0 0h16v16H0z"
            data-name="Ret\xE2ngulo 227"
            transform="translate(473 345)"
          />
        </clipPath>
        <style>
          {
            ".mail_svg__prefix__cls-3{fill:currentColor;stroke:currentColor;stroke-width:.3px}"
          }
        </style>
      </defs>
      <g
        id="mail_svg__prefix__Grupo_de_m\xE1scara_42"
        clipPath="url(#mail_svg__prefix__clip-path)"
        data-name="Grupo de m\xE1scara 42"
        transform="translate(-473 -345)"
      >
        <g
          id="mail_svg__prefix__email_2_"
          data-name="email (2)"
          transform="translate(473.5 345.375)"
        >
          <g
            id="mail_svg__prefix__Grupo_380"
            data-name="Grupo 380"
            transform="translate(0 2.125)"
          >
            <g id="mail_svg__prefix__Grupo_379" data-name="Grupo 379">
              <path
                id="mail_svg__prefix__Caminho_121"
                d="M13.242 2.125H1.758A1.739 1.739 0 000 3.84v7.32a1.739 1.739 0 001.758 1.715h11.484A1.739 1.739 0 0015 11.16V3.84a1.739 1.739 0 00-1.758-1.715zm.586 9.035a.58.58 0 01-.586.572H1.758a.58.58 0 01-.586-.572V3.84a.58.58 0 01.586-.572h11.484a.58.58 0 01.586.572z"
                className="mail_svg__prefix__cls-3"
                data-name="Caminho 121"
                transform="translate(0 -2.125)"
              />
            </g>
          </g>
          <g
            id="mail_svg__prefix__Grupo_382"
            data-name="Grupo 382"
            transform="translate(.61 2.904)"
          >
            <g id="mail_svg__prefix__Grupo_381" data-name="Grupo 381">
              <path
                id="mail_svg__prefix__Caminho_122"
                d="M13.694 2.9L7.5 7.846 1.306 2.9l-.7 1L7.5 9.4l6.89-5.5z"
                className="mail_svg__prefix__cls-3"
                data-name="Caminho 122"
                transform="translate(-.61 -2.904)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgMail;

